import * as React from 'react';
import TrackVisibility from 'react-on-screen';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { brandColors, device, fonts } from '../../styles/variables';
import Count from './Count';

const Wrapper = styled.div`
  width: 100%;
`;

const Title = styled.h1`
  ${({ color }) => `
    color: ${color};
    font-family: ${fonts.athelas};
    font-style: italic;
    letter-spacing: 1px;
    text-align: center;
    margin-top: -28px;
    font-size: 18px;
    line-height: 38px;
    font-weight: normal;
    @media ${device.tablet} {
      font-size: 24px;
      line-height: 44px;
    }
  `};
`;

class Counter extends React.PureComponent {
  render() {
    const { title, color, maxCount, staticCount, className, addSymbol } = this.props;

    let showTitle;
    if (title) {
      showTitle = (
        <Title className={className} color={color}>
          {title}
        </Title>
      );
    }

    return (
      <Wrapper>
        <TrackVisibility once>
          {({ isVisible }) => (
            <Count
              className={className}
              color={color}
              maxCount={maxCount}
              isVisible={isVisible}
              staticCount={staticCount}
              addSymbol={addSymbol}
            />
          )}
        </TrackVisibility>
        {showTitle}
      </Wrapper>
    );
  }
}

Counter.defaultProps = {
  maxCount: 0,
  title: '',
  color: brandColors.white,
  staticCount: false,
  className: '',
  addSymbol: ''
};

Counter.propTypes = {
  maxCount: PropTypes.number,
  title: PropTypes.string,
  color: PropTypes.string,
  staticCount: PropTypes.bool,
  className: PropTypes.string,
  addSymbol: PropTypes.string
};

export default connect()(Counter);



// WEBPACK FOOTER //
// ./src/components/Counter/index.jsx